import { render } from "./CourseFinder.vue?vue&type=template&id=2253ced8&scoped=true"
import script from "./CourseFinder.vue?vue&type=script&lang=js"
export * from "./CourseFinder.vue?vue&type=script&lang=js"

import "./CourseFinder.vue?vue&type=style&index=0&id=2253ced8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2253ced8"]])

export default __exports__